import { gql } from "@apollo/client";
import { TOPIC_BASIC_FIELDS_FRAGMENT } from "../fragments/TopicFragments";

const GET_FUTURE_CLASSES = gql`
  query GetFutureClasses($first: Int, $after: String) {
    bookedClasses(first: $first, after: $after) {
      pageInfo {
        endCursor
        startCursor
        hasPreviousPage
        hasNextPage
      }
      nodes {
        id
        date
        time
        classType
        classSize
        category
        seatsRemaining
        credits
        language {
          id
          englishName
          realName
        }
        teacher {
          id
          avatar
          givenName
          familyName
        }
        topic {
          ...TopicBasicFields
        }
        chapter {
          name
        }
        level {
          title
        }
        city {
          id
          name
        }
      }
    }
  }
  ${TOPIC_BASIC_FIELDS_FRAGMENT}
`;

export default GET_FUTURE_CLASSES;
